import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.NetSuiteContent', {
    netSuiteName: 'NetSuite',
    connectToOrganisation: 'Connect your NetSuite organisation',
    connectToOrgHeader: 'Perfect for a quick start on live NetSuite data.',
    buttonConnectToOrg: 'Connect to NetSuite',
});
